import "./NewSimulationComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {CompanyInfo} from "../../../types/Company";
import {NewSimulationRecord} from "../../models/TradeSimulationRecords";
import {HistoricalPriceRange} from "../../../services/price/historical/HistoricalPriceModels";
import {Expiries} from "../../../services/expiry/Expiries";
import {ReplaySubject, Subject} from "rxjs";
import {TradeSimulatorViewStore} from "../../service/TradeSimulatorViewStore";
import {HistoricalPriceService} from "../../../services/price/historical/HistoricalPriceService";
import {IsoDate} from "../../../pseudo-types/DateTypes";

export const NewSimulation = "tfNewSimulation";

export function newSimulation(): IComponentOptions {
    return {
        templateUrl: "app/trade-simulator/components/new-simulation/NewSimulationComponent.html",
        controllerAs: "ctrl",
        controller: NewSimulationComponentController,
        bindings: {
            viewStore: "<"
        }

    };
}

export class NewSimulationComponentController implements IOnInit, IOnDestroy {

    public viewStore: TradeSimulatorViewStore;

    public startingDate: IsoDate | null;
    public historicalPriceRange: HistoricalPriceRange;
    public expiries: Expiries;
    public holidays: Array<Date>;
    public expiryDates: Array<Date>;

    private selectedCompany: CompanyInfo | null;
    private simulationName: string | null;
    private initialBalance: number | null;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope, private historicalPriceService: HistoricalPriceService) {
        this.reset();
    }

    public $onInit(): void {
        this.viewStore
            .holidays
            .takeUntil(this.destroyed$)
            .subscribe(holidays => this.$scope.$applyAsync(() => this.holidays = holidays));
        this.viewStore
            .expiries
            .takeUntil(this.destroyed$)
            .subscribe(expiries => this.$scope.$applyAsync(() => this.expiries = expiries));
    }

    public async companyChanged(company: CompanyInfo) {
        const previous = this.selectedCompany;
        this.selectedCompany = company;
        this.simulationName = this.defaultName(previous, company);
        this.expiryDates = this.expiries.forUnderlying(this.selectedCompany.code)
                               .ofType("MONTHLY", "QUARTERLY")
                               .expiryDates()
                               .map(e => new Date(e));
        this.historicalPriceRange = await this.historicalPriceService.priceRange(this.selectedCompany.code);
    }

    private defaultName(previous: CompanyInfo | null, current: CompanyInfo) {
        if (previous == null || this.simulationName == null) {
            return `${current.code} Simulation`;
        } else if (this.simulationName.includes(previous.code)) {
            return this.simulationName.replace(previous.code, current.code);
        } else {
            return this.simulationName;
        }
    }

    public create() {
        if (this.simulationName != null &&
            this.selectedCompany != null &&
            this.initialBalance != null &&
            this.startingDate != null) {

            const simulation: NewSimulationRecord = {
                name: this.simulationName,
                underlying: this.selectedCompany.code,
                initialBalance: this.initialBalance,
                activeDate: this.startingDate,
                trades: []
            };
            this.viewStore.create(simulation);
            this.reset();
        }
    }

    private reset() {
        this.selectedCompany = null;
        this.simulationName = null;
        this.startingDate = null;
        this.initialBalance = 50000;
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
